import React from "react";
import {observer} from "mobx-react";
import {StandardDialogPageComponent} from "../../../../../components/modal/page/standard-dialog-page.component";
import {StandardDialogHeaderComponent} from "../../../../../components/modal/header/standard-dialog-header.component";
import {
    StandardDialogContentComponent
} from "../../../../../components/modal/content/standard-dialog-content.component";
import {StandardDialogFooterComponent} from "../../../../../components/modal/footer/standard-dialog-footer.component";
import {IDialogConfirmationHandler} from "../../../../../services/dialog/dialog.service.interface";
import {IBookingViewModel} from "../../../../../services/booking/models/booking-view-model.interface";
import {
    IInsuranceRefundDetailsResponse
} from "../../../../../services/airline-webapi/responses/insurance-refund-details.response";
import {useServices} from "../../../../../hooks/use-services.hook";
import {ContinueButtonComponent} from "../../../../../components/continue-button/continue-button.component";
import styled from "styled-components";
import {useScreenMediaQueriesChecks} from "../../../../../hooks/use-screen-media-queries-checks.hook";
import {CheckedIcon} from "../../../../../assets/svg/checked.icon";

const DialogContentBox = styled.div`
    display: flex;
    flex-direction: row;
    gap: ${props => props.theme.spacing.flexGap24};
    width: 100%;
    align-items: flex-start;
    font-size: ${props => props.theme.fontSize.body1};
    
`

const CheckIconBox = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
`

const ConfirmationDetailsBox = styled.div`
    display: flex;
    flex-direction: column;
    gap: ${props => props.theme.spacing.flexGap16};
    flex-grow: 1;
`

const TitleBox = styled.div`
    font-size: ${props => props.theme.fontSize.h3};
    font-weight: ${props => props.theme.fontWeight.semiBold};
    color: ${props => props.theme.colors.primaryShade};
`

const SubtitleBox = styled.div`
    font-weight: ${props => props.theme.fontWeight.medium};
`

const UnorderedListBox = styled.ul`
    display: flex;
    flex-direction: column;
    gap: ${props => props.theme.spacing.flexGap16};
    margin: 0;
`

interface InsuranceClaimConfirmationDialogComponentProps {
    dialogHandler: IDialogConfirmationHandler;
    booking: IBookingViewModel;
    refundDetails: IInsuranceRefundDetailsResponse;
}
export const InsuranceClaimConfirmationDialogComponent: React.FC<InsuranceClaimConfirmationDialogComponentProps> = observer((props) => {
    const services = useServices();
    const screenMediaQuery = useScreenMediaQueriesChecks();

    const purchaseAmountToRefund = props.booking.createPrice(props.refundDetails.purchaseAmountToRefund);
    const taxesAmountToRefund = props.booking.createPrice(props.refundDetails.taxesAmountToRefund);

    return (
        <StandardDialogPageComponent>
            <StandardDialogHeaderComponent dialogHandler={props.dialogHandler} title={services.language.translate('Booking successfully cancelled')} renderTitleOnTheFirstRow={true}/>
            <StandardDialogContentComponent dialogHandler={props.dialogHandler}>
                <DialogContentBox>
                    <CheckIconBox>
                        <CheckedIcon size={screenMediaQuery.smallScreen ? 3 : 4} color={services.theme.currentTheme.colors.primary}/>
                    </CheckIconBox>
                    <ConfirmationDetailsBox>
                        <TitleBox>
                            {services.language.translationFor('Your {amount} flight voucher is on its way.')
                                .withParams({amount: purchaseAmountToRefund.toString()})}
                        </TitleBox>
                        <SubtitleBox>
                            {services.language.translationFor('A confirmation email will be sent shortly to {emailAddress}.')
                                .withParams({emailAddress: props.booking.contact.fields.emailAddress.value ?? ""})}
                        </SubtitleBox>
                        <SubtitleBox>
                            {services.language.translate('You will receive:')}
                        </SubtitleBox>
                        <UnorderedListBox>
                            <li>
                                {services.language.translationFor('{amount} flight voucher in a separate email, ready to be used on your next booking')
                                    .withParams({amount: purchaseAmountToRefund.toString()})}
                            </li>
                            <li>
                                {services.language.translationFor('{amount} in refundable taxes, reimbursed separately by AeroItalia to your original payment method')
                                    .withParams({amount: taxesAmountToRefund.toString()})}
                            </li>
                        </UnorderedListBox>
                    </ConfirmationDetailsBox>
                </DialogContentBox>
            </StandardDialogContentComponent>

            <StandardDialogFooterComponent dialogHandler={props.dialogHandler}>
                <ContinueButtonComponent onClick={() => props.dialogHandler.accept()} fullWidth={true}/>
            </StandardDialogFooterComponent>
        </StandardDialogPageComponent>
    );
})